function bindPseudoSwatches(scope = document) {
  const allSwatchWrappers = scope.querySelectorAll(".se-custom-swatches-wrapper[data-sku][data-product]");

  if (!allSwatchWrappers.length) return;

  allSwatchWrappers.forEach(async (wrapper, index) => {
    if (wrapper.classList.contains("bound")) return;
    wrapper.classList.add("bound");

    const sku = wrapper.dataset.sku;
    const styleID = sku.split("-")[0];
    const productId = wrapper.dataset.product;
    const collectionHandle = wrapper.dataset.collection || null;
    const pseudoVariantsDOM = wrapper.querySelector("[data-pseudovariants]");
    const pseudoContainer = wrapper.querySelector("[data-pseudo]");
    const optionValueEl = wrapper.querySelector("[data-optionvalue]");
    const defaultColorEl = wrapper.querySelector("[data-defaultcolor]");
    const context = wrapper.dataset.context || "product";
    const productHandle = wrapper.dataset.handle || null;

    let defaultColor = null;
    if (context === "product" && defaultColorEl) {
      defaultColor = defaultColorEl.dataset.defaultcolor;
    } else {
      const titleEl = wrapper.dataset.productTitle || null;
      if (titleEl) {
        defaultColor = titleEl.split("- ")[1]?.trim();
      }
    }

    if (!styleID || !pseudoVariantsDOM || !pseudoContainer || (context === "product" && !defaultColor)) return;

    try {
      let products = [];
      if (context === "product" && !collectionHandle && productHandle) {
        const prodResp = await fetch(`/products/${productHandle}.json`);
        const productJson = await prodResp.json();
        const p = productJson.product;
        products = p.variants.map(v => ({
          id: v.id,
          title: `${p.title} - ${v.option1}`,
          available: v.available,
          thumbnailImage: p.images.length ? p.images[0].src : "",
          url: `/products/${p.handle}?variant=${v.id}`,
          media: [{ preview_image: { src: p.images[0]?.src || "" } }],
          images: p.images
        }));
      } else {
        const url = `${window.location.origin}/collections/all/${styleID}?view=jsonprod`;
        const response = await fetch(url);
        const pseudoVariants = await response.json();
        products = pseudoVariants.products;
      }

      if (!products || products.length === 0) {
        pseudoContainer.classList.add("hide");
        return;
      }

      let swatches = [], oos = [];

      products.forEach((product) => {
        const color = product.title.split("- ")[1]?.trim();
        const isDisabled = !product.available;
        let isActive = false;
        const isCurrent = product.id.toString() === productId;

        if (context === "product" && color === defaultColor && !isDisabled && swatches.every(s => !s.active)) {
          isActive = true;
        }

        const backgroundThumb = product.thumbnailImage || "";
        const masterImage = context !== "product"
          ? (product.images?.[0]?.src || "")
          : product.thumbnailImage || "";

        const mediaId = product.media?.[0]?.preview_image?.src || "";

        const item = {
          html: `
            <li class='pseudo-variant${isActive ? " active" : ""}${isDisabled ? " disabled" : ""}' ${isDisabled ? "disabled" : ""} 
                data-title='${product.title}' data-media='${mediaId}' data-master='${masterImage}' data-url='${product.url}' data-product='${productId}' data-pseudovariant>
              <a href='${product.url}' style="background-image: url('${backgroundThumb}')"></a>
            </li>`,
          isCurrent,
          isDisabled,
          active: isActive
        };

        if (isDisabled) {
          oos.push(item.html);
        } else {
          swatches.push(item);
        }
      });

      swatches.sort((a, b) => {
        if (context !== "product") {
          if (b.isCurrent) return 1;
          if (a.isCurrent) return -1;
        }
        return (b.active ? 1 : 0) - (a.active ? 1 : 0);
      });

      if (context !== "product" && swatches.length > 1) {
        swatches.forEach(s => s.active = false);
        swatches[0].active = true;
      }

      let limitedSwatches = swatches;
      let extraSwatchesCount = 0;

      if (context !== "product") {
        if (swatches.length > 3) {
          limitedSwatches = swatches.slice(0, 3);
          extraSwatchesCount = swatches.length - 3;
          if (extraSwatchesCount > 0) {
            limitedSwatches.push({
              html: `<li class='pseudo-variant pseudo-variant-more'><a href='${products[0].url}'>+${extraSwatchesCount}</a></li>`,
              active: false
            });
          }
        }
      }

      pseudoVariantsDOM.innerHTML = limitedSwatches.map(s => {
        return s.active ? s.html.replace("pseudo-variant", "pseudo-variant active") : s.html;
      }).join("") + oos.join("");

      if (context !== "product") {
        const allSwatches = wrapper.querySelectorAll("[data-pseudovariant]:not(.disabled)");

        allSwatches.forEach((swatch) => {
          swatch.addEventListener("click", (e) => {
            e.preventDefault();
            const pid = swatch.dataset.product;
            const imageUrl = swatch.dataset.master;
            const productUrl = swatch.dataset.url;
            const title = swatch.dataset.title?.split("- ")[1];

            allSwatches.forEach(s => s.classList.remove("active"));
            swatch.classList.add("active");

            const sliderWrapper = document.querySelector(`.se-slider-wrapper[data-product="${pid}"]`);
            const placeholder = document.querySelector(`.se-image-placeholder[data-product="${pid}"]`);
            const productBlock = document.querySelector(`.product-block[data-product-id="${pid}"]`);

            if (sliderWrapper) sliderWrapper.style.display = "none";
            if (placeholder && imageUrl) {
              placeholder.innerHTML = `<div class="img-ar img-ar--cover" style="--aspect-ratio: 0.67">
                <img src="${imageUrl}" class="theme-img" loading="eager" />
              </div>`;
            }

            if (productBlock) {
              productBlock.classList.add("se-swatch-clicked");

              const quickBtnDesktop = productBlock.querySelector(".quickbuy-toggle.desktop-only");
              const quickBtnMobile = productBlock.querySelector(".quickbuy-toggle.mobile-only");
              const imageLink = productBlock.querySelector(".image-cont a.product-link");
              const titleLink = productBlock.querySelector(".product-block__detail a.product-link");

              if (quickBtnDesktop && productUrl) quickBtnDesktop.setAttribute("href", productUrl);
              if (quickBtnMobile && productUrl) quickBtnMobile.setAttribute("href", productUrl);
              if (imageLink && productUrl) imageLink.setAttribute("href", productUrl);
              if (titleLink && productUrl) titleLink.setAttribute("href", productUrl);

              if (optionValueEl && title) optionValueEl.textContent = title;
            }
          });
        });
      }

      if (context === "product" && optionValueEl) {
        const activeVariants = wrapper.querySelectorAll("[data-pseudovariant]:not([disabled])");
        activeVariants.forEach((el) => {
          el.addEventListener("mouseover", () => {
            const c = el.dataset.title.split("- ")[1];
            if (c) optionValueEl.innerHTML = c;
          });
          el.addEventListener("mouseleave", () => {
            const c = activeVariants[0].dataset.title.split("- ")[1];
            if (c) optionValueEl.innerHTML = c;
          });
        });
      }
    } catch (error) {
      console.error("Pseudo Variant Error:", error);
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  bindPseudoSwatches();
  if (window.location.pathname.includes("/collections/")) {
    const scrollContainer = document.querySelector("#CollectionAjaxContent, .collection, main");
    if (scrollContainer) {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) bindPseudoSwatches(node);
          });
        }
      });
      observer.observe(scrollContainer, { childList: true, subtree: true });
    }
  }
});
